import React, { FunctionComponent } from "react";
import styles from "./Section.module.scss";
import SectionProps from "./SectionProps.interface";

const Section: FunctionComponent<SectionProps> = (props): JSX.Element => {
    const getClass = () => {
        switch (props.className) {
            case "white":
                return styles.white;
            case "white-alt":
                return styles.whiteAlt;
            case "intro":
                return styles.intro;
            case "beach":
                return styles.beach;
        }
        return "";
    };

    return (
        <div className={`${styles.mainSection} ${getClass()} ${props.state === "active" ? styles.active : ""} ${props.state === "up" ? styles.up : ""} ${props.state === "down" ? styles.active : ""}`}>
            {props.children}
        </div>
    );
};

export default Section;